var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersonCheckmark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 162,
    viewBox: "0 0 162 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_718_2633",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 162,
    height: 162
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 162,
    height: 162,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_718_2633)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_718_2633",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 162,
    height: 162
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 162,
    height: 162,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_718_2633)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0526 106.235C17.8492 100.439 25.7111 97.1821 33.9087 97.1821H80.9998C89.1974 97.1821 97.0593 100.439 102.856 106.235C108.652 112.032 111.909 119.894 111.909 128.091V141.546C111.909 143.755 110.118 145.546 107.909 145.546C105.7 145.546 103.909 143.755 103.909 141.546V128.091C103.909 122.015 101.495 116.188 97.199 111.892C92.9027 107.596 87.0757 105.182 80.9998 105.182H33.9087C27.8328 105.182 22.0058 107.596 17.7095 111.892C13.4132 116.188 10.9995 122.015 10.9995 128.091V141.546C10.9995 143.755 9.20865 145.546 6.99951 145.546C4.79037 145.546 2.99951 143.755 2.99951 141.546V128.091C2.99951 119.894 6.25601 112.032 12.0526 106.235Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.4546 24.4543C44.8022 24.4543 34.5454 34.7111 34.5454 47.3635C34.5454 60.0159 44.8022 70.2727 57.4546 70.2727C70.107 70.2727 80.3638 60.0159 80.3638 47.3635C80.3638 34.7111 70.107 24.4543 57.4546 24.4543ZM26.5454 47.3635C26.5454 30.2929 40.3839 16.4543 57.4546 16.4543C74.5253 16.4543 88.3638 30.2929 88.3638 47.3635C88.3638 64.4342 74.5253 78.2727 57.4546 78.2727C40.3839 78.2727 26.5454 64.4342 26.5454 47.3635Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.828 57.9897C159.391 59.5518 159.391 62.0844 157.828 63.6465L130.919 90.5557C129.357 92.1178 126.824 92.1178 125.262 90.5557L111.808 77.1011C110.246 75.539 110.246 73.0064 111.808 71.4443C113.37 69.8822 115.903 69.8822 117.465 71.4443L128.091 82.0704L152.172 57.9897C153.734 56.4276 156.266 56.4276 157.828 57.9897Z",
    fill: "black"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonCheckmark);
export default __webpack_public_path__ + "static/media/PersonCheckmark.d9bc3f30d48d07071a2b28c5ab132d28.svg";
export { ForwardRef as ReactComponent };